import { getCloudinaryVideoPoster, refineCloudinaryUrlQuality } from "@/apiUtils/commonUtils";
import React, { useEffect, useRef, useState } from "react";

interface LazyLoadedVideoProps extends React.VideoHTMLAttributes<HTMLVideoElement> {
  videoRef?: React.RefObject<HTMLVideoElement>;
  src?: string;
}

const LazyLoadedVideo: React.FC<LazyLoadedVideoProps> = (props) => {
  const { src, poster, videoRef, preload = "none", loop = true, style, className, ...rest } = props;
  const localRef = useRef<HTMLVideoElement | null>(null);
  const finalRef = videoRef || localRef;
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const videoElement = finalRef.current;

    if (!videoElement) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !isLoaded) {
          videoElement.src = refineCloudinaryUrlQuality(src!);
          videoElement.play().catch((error) => {
            console.error("Error playing video:", error);
          });
          setIsLoaded(true);
        }
      },
      { threshold: 0.1 },
    );

    if (videoElement) {
      observer.observe(videoElement);
    }

    return () => {
      if (videoElement) {
        observer.unobserve(videoElement);
      }
    };
  }, [src, finalRef, isLoaded]);

  return (
    <video
      ref={finalRef}
      poster={poster || getCloudinaryVideoPoster(src!)}
      //   autoPlay
      muted
      playsInline
      loop={loop}
      preload={preload}
      disablePictureInPicture
      controlsList="nodownload nofullscreen noremoteplayback"
      className={className}
      style={{
        ...style,
        objectFit: style?.objectFit || "cover",
        pointerEvents: "none",
      }}
      onContextMenu={(e) => e.preventDefault()}
      {...rest}
    />
  );
};

export default LazyLoadedVideo;
